export type ChatConnectionStatus = 'connected' | 'connecting' | 'reconnecting' | 'disconnected' | 'subscriptionError';

export const CHAT_CONNECTION_STATUS_LABEL: { [key in ChatConnectionStatus]: string } = {
  connected: 'Connected',
  connecting: 'Connecting…',
  reconnecting: 'Reconnecting…',
  disconnected: 'Disconnected',
  subscriptionError: 'Live updates unavailable',
};

// The transport can be connected overall while a specific chat's channel
// failed to subscribe (e.g. auth rejected) - surface that instead of
// misleadingly showing "Connected" for a chat that isn't actually live.
export const getChatConnectionStatus = (
  hasSubscriptionError: boolean,
  connected: boolean,
  connecting: boolean,
  reconnecting: boolean,
): ChatConnectionStatus => {
  if (hasSubscriptionError) {
    return 'subscriptionError';
  }
  if (connected) {
    return 'connected';
  }
  if (reconnecting) {
    return 'reconnecting';
  }
  if (connecting) {
    return 'connecting';
  }
  return 'disconnected';
};

export const getLastMessageToken = (id: string) => `lastMessage_${id}`;

export const getLastReceivedMessageToken = (id: string) => `lastReceivedMessage_${id}`;

// Whether a chat has messages newer than the last one we've read, based on
// sequence ids persisted to localStorage - lets the "has unread" signal
// survive a refresh without having to fetch every chat's message history up
// front. This is a presence check only (true/false), never an exact count -
// callers that need the real number must wait for `chat.loaded`.
export const hasUnreadMessages = (chatId: string): boolean => {
  const lastReceived = Number(localStorage.getItem(getLastReceivedMessageToken(chatId))) || 0;
  const lastRead = Number(localStorage.getItem(getLastMessageToken(chatId))) || 0;
  return lastReceived > lastRead;
};

